"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotImplementedError = void 0;
const BaseError_1 = require("./BaseError");
class NotImplementedError extends BaseError_1.BaseError {
    constructor(description = "Not Implemented") {
        super("NotImplementedError", 501, description, true);
    }
}
exports.NotImplementedError = NotImplementedError;
